import { Avatar as MuiAvatar } from '@mui/material';
import { isBase64 } from 'components/ui/utils/isBase64.js';
import type { FC } from 'react';
import { forwardRef } from 'react';

import { useStyles } from './Avatar.styles.js';
import type { AvatarProps } from './Avatar.types.js';
import { InitialsIcon } from './InitialsIcon/index.js';

export const Avatar: FC<AvatarProps> = forwardRef(
  ({ src = '', variant, color, ...props }, ref) => {
    const styles = useStyles({ size: props.size, onClick: props.onClick });
    const isImage = isBase64(src) || src.includes('.svg');

    return isImage
      ? (
          <MuiAvatar
            ref={ref}
            style={styles}
            src={src}
            sx={{ '& img': { objectFit: 'contain' } }}
            aria-hidden
            {...props}
          />
        )
      : (
          <InitialsIcon
            text={src}
            aria-hidden
            {...props}
            variant={variant ?? 'filled'}
            style={styles}
          />
        );
  },
);

Avatar.displayName = 'Avatar';
